<h1 mat-dialog-title>Revert Changes</h1>
<div mat-dialog-content>You are about to lose your changes. Are you sure you want to revert them?</div>
<div mat-dialog-actions class="float-right">
  <button class="btn btn-sm btn-secondary mr-2" (click)="cancel()">Cancel</button>
  <button type="submit" class="btn btn-sm btn-danger" (click)="revert()">Revert</button>
</div>
